import {
    freezed
} from "./adapters/madnesAssetsAdapter"
import {
    madnes_audio_continue,
    madnes_audio_loop, madnes_audio_pause,
    madnes_audio_play,
    madnes_audio_stop
} from "../framework/src/engine/madnes/madnes_audio";
import {
    madnes_add_to_render,
    madnes_alpha_to, madnes_fall_to,
    madnes_move_to,
    madnes_rem_from_render, madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {
    ico_he,
    ico_wi,
    in_free_spins,
    picture_convert,
    reels_pos,
    round_running,
    server_result,
    server_config,
    behavior_config,
    set_rotated,
    rotated,
    alldone,
    forcestopnow,
    states,
    wi,
    fps,
    super_win,
    big_win,
    win_anim_skip_click,
    set_forcestopnow,
    reels_lenghts,
    set_inanim,
    set_inwincount,
    set_inbigwin,
    set_inmoneyadd,
    he,
    mega_win,
    inbigwin, inmoneyadd
} from "../framework/src/engine/madnes/madnes_variables";
import {
    madnes_anim_add, madnes_anim_is_playing,
    madnes_anim_loop,
    madnes_anim_play,
    madnes_anim_stop, madnes_show_money, madnes_start_coin, madnes_stop_coin
} from "../framework/src/engine/madnes/madnes_anims";
import {
    bet, madnes_end_round,
    madnes_fill_range,
    madnes_get_currtime,
    madnes_money_to_coin, madnes_reels_start, madnes_reels_stop, madnes_set_blend_mode, madnes_set_win, madnes_add_win,
    madnes_win_anim_reset, madnes_win_anim_skip, win, madnes_is_in_autostart
} from "../framework/src/engine/madnes/madnes";
import {
    madnes_add_sprite,
    madnes_add_to_group,
    madnes_get_alpha,
    madnes_get_pos_x,
    madnes_get_pos_y,
    madnes_get_texture, madnes_key_exist,
    madnes_remove_sprite,
    madnes_set_alpha,
    madnes_set_img_center,
    madnes_set_pos,
    madnes_set_pos_y,
    madnes_set_scale,
    madnes_set_texture,
    madnes_set_visible
} from "../framework/src/engine/madnes/madnes_object";
import {
    madnes_graphics_begin_fill,
    madnes_graphics_clear,
    madnes_graphics_draw_rectangle
} from "../framework/src/engine/madnes/madnes_draw";
import {STATES} from "../framework/src/states/states";
import {cylinder_pos, freepanelpos, icons, last_symbol, set_freepanelpos, symbols} from "./ib27_config";
import {ib27_print_reels, result_lock, set_result_lock} from "./ib27_core_printer";
import {ib27_from_mystery, ib27_mystery_start, ib27_show_win_sum_start, set_ib27_from_mystery} from "./ib27_anims";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";

var rotate_start_time = 0;
var rotate_start_pos = [];
var rotate_start_in_accel = 0;
var rotate_start_swing = 0;
var can_stop = 0;
var rotate_control_start_time = 0;
var rotate_control_swing_end = 0;

var in_free_spins_pos = 0;
var in_free_spins_total = 0;

var autospin_force = false;
var autospin_force_enabled = false;

export function ib27_rotate_run()
{
    if(round_running) //waiting for end round
    {
        return;
    }
    else
    {
        ib27_rotate_start();
    }
}

function ib27_rotate_start()
{
    if(rotated == 0)
    {
        // madnes_on_round_start();

        // madnes_show_stop();

        madnes_win_anim_reset();

        for(var i in server_config.logic.reels)
        {
            while(stopposin[i] > server_config.logic.reels[i].length)
            {
                stopposin[i] = stopposin[i] * 1 - server_config.logic.reels[i].length;
                stopposin_old[i] = stopposin[i];
                reels_pos[i] = stopposin[i] * ico_he;
            }
        }

        // if(autostart != "∞" && autostart*1 > 0 && !in_free_spins)
        // {
        // 	autostart = autostart * 1 - 1;
        // }
        set_rotated(1); //rotated = 1;

        startposin = JSON.parse(JSON.stringify(stopposin));

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            symbols[i] = 0;
            last_symbol[i] = -1;
            rotate_start_pos[i] = reels_pos[i];
        }


        // if(!in_free_spins)
        // {
        // 	madnes_new_round();
        //     force_res = "";
        // }

        can_stop = 0;

        rotate_start_time = madnes_get_currtime();

        rotate_control_start_time = 0;
        rotate_start_in_accel = 0;
        rotate_start_swing = 0;
        set_forcestopnow(0); //forcestopnow = 0;
        scatters_runned = false;



        var sound_tmp = "reel_rotation_" + ( ( Math.round( Math.random() * 100 ) % 3 ) + 3 );
        madnes_audio_play(sound_tmp);

        madnes_add_to_render(ib27_rotate_start);
        madnes_reels_start();
    }
    else
    {
        var time = madnes_get_currtime() - rotate_start_time;

        if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // back
            var time_perc = ( ( 100 / ( behavior_config.reel.acceleration.moveBackTime * 1000 ) ) * time ) / 100;
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // keep
            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * 1 );
            }
        }
        else if(
            rotate_start_swing < behavior_config.reel.acceleration.swingCount &&

            //time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveTime * 1000 &&
            time < behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000 + behavior_config.reel.acceleration.moveBackTime * 1000 &&
            rotate_start_in_accel == 0
        )
        {
            // acc

            var time_perc =
                1 - (
                    (
                        (
                            100 / (
                                //behavior_config.reel.acceleration.moveTime * 1000
                                behavior_config.reel.acceleration.moveBackTime * 1000
                            )
                        ) * (
                            time - (
                                behavior_config.reel.acceleration.moveBackTime * 1000 + behavior_config.reel.acceleration.keepTime * 1000
                            )
                        )
                    ) / 100
                );

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] - ( behavior_config.reel.acceleration.accelerationHeight * ico_he * time_perc );
            }

        }
        else if(
            rotate_start_in_accel == 0
        )
        {
            // rotate accel start or repeat

            madnes_audio_loop("reels");

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i];
            }

            rotate_start_time = madnes_get_currtime();

            if(++rotate_start_swing >= behavior_config.reel.acceleration.swingCount)
            {

                for(var i = 0; i < cylinder_pos.length; i++)
                {
                    if(behavior_config.reel.spin.motionBlur == 1)
                    {
                        madnes_anim_play("reels_bufer_" + i + "_S0", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S1", "blur");
                        madnes_anim_play("reels_bufer_" + i + "_S2", "blur");

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "blur");
                        }

                    }
                }

                rotate_start_in_accel = 1;

                // ib27_rotate_control_start_sym = Math.round(rotate_start_pos[0] / ico_he);
                rotate_control_start_time = madnes_get_currtime();
            }
        }
        else if(
            rotate_start_in_accel == 1
        )
        {
            // accel start
            var start_speed = behavior_config.reel.acceleration.accelerationHeight / behavior_config.reel.acceleration.moveBackTime;

            if(!isFinite(start_speed) || isNaN(start_speed))
            {
                start_speed = 0;
            }

            var end_speed = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                end_speed = behavior_config.reel.spin.freeSpinSpeed;
            }

            var end_time = behavior_config.reel.spin.timeToReachFullSpeed * 1000;

            var perc = 0;
            var speed = 0;
            var pos = 0;
            var sampling = 10;

            for(var i = 0; i <= time; i = i * 1 + sampling * 1)
            {
                perc = 100 / end_time * i;
                if(!isFinite(perc) || isNaN(perc))
                {
                    perc = 0;
                }
                speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
            }

            for(var i = 0; i < cylinder_pos.length; i++)
            {
                reels_pos[i] = rotate_start_pos[i] + pos * ico_he;
            }

            if(
                !(
                    time < behavior_config.reel.spin.timeToReachFullSpeed * 1000
                )
            )
            {
                pos = 0;

                for(var i = 0; i <= ( behavior_config.reel.spin.timeToReachFullSpeed * 1000 ); i = i * 1 + sampling * 1)
                {
                    perc = 100 / end_time * i;
                    if(!isFinite(perc) || isNaN(perc))
                    {
                        perc = 0;
                    }
                    speed = ( ( end_speed - start_speed ) * ( perc / 100 ) ) + start_speed * 1;
                    pos = pos * 1 + ( speed / ( 1000 / ( sampling * 1 ) ) );
                }

                rotate_control_swing_end = pos;

                madnes_rem_from_render(ib27_rotate_start);
                madnes_add_to_render(ib27_rotate_control);
            }
        }

        ib27_print_reels();
    }
}

export var stopposin = new Array();
export var startposin = new Array();

var stopposin_round = new Array();
var stopping = new Array();

export var stopposin_old = new Array();
var stoppostime_br = new Array();
var stoppostime = new Array();

var stoppos_swing = new Array();

var scatters = 0;
var saloons = 0;
var all_set_for_stop = 0;

var scatters_runned = false;
function ib27_rotate_control()
{
    var time = madnes_get_currtime();

    if(rotated == 1 || all_set_for_stop == 0)
    {
        // Toci se a zatim se neceka ukonceni

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(server_result != null && result_lock == 0)
            {
                stopposin[i] = -1;
                stopposin_round[i] = 0;
                stopping[i] = 0;
                stoppostime_br[i] = -1;
                stoppos_swing[i] = 0;
                stoppostime[i] = -1;
                can_stop = 1;
            }

            alldone[i] = 0;

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }

            reels_pos[i] =
                (
                    rotate_start_pos[i] +
                    (
                        (
                            (
                                (
                                    time - rotate_control_start_time - (
                                        behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                    )
                                ) / 1000
                            ) * cs
                        ) + rotate_control_swing_end
                    ) * ico_he
                );
            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );
        }

        scatters = 0;
        saloons = 0;

    }
    else
    {
        // Je na case ukoncit toceni na spravnych pozicich

        for(var i = 0; i < cylinder_pos.length; i++)
        {
            if(stopposin[i] == -1)
            {
                // Nejsou nastaveny pozice pro ukonceni -> nastavuji
                if(forcestopnow === 1)
                {
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + ( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i];
                    }

                }
                else
                {
                    var del = 1;
                    if(typeof behavior_config.reel.spin.delayBetweenReelStops != "undefined")
                    {
                        del = behavior_config.reel.spin.delayBetweenReelStops;
                    }
                    var cs = behavior_config.reel.spin.commonSpeed;
                    if(in_free_spins)
                    {
                        cs = behavior_config.reel.spin.freeSpinSpeed;
                    }

                    var strns = cs * behavior_config.reel.spin.timeToReachNullSpeed;

                    stopposin[i] = Math.round(reels_pos[i] / ico_he) + /*(i * del) + */( 2 + /* 3 + Math.floor( cs / 4 ) +*/ Math.ceil( strns ) );

                    if(i > 0)
                    {
                        stopposin[i] = ( reels_lenghts[0] - startposin[0] ) + ( ( stopposin_round[0] - 1 ) * reels_lenghts[0] ) + stopposin[0] + startposin[i] + ( i * del );
                    }
                }
                /*
                var sc_tmp = 0;
                var sa_tmp = 0;

                var add_tmp_sc = 0;
                var add_tmp_sa = 0;

                for(var j = 0; j < i; j++)
                {
                    for(var spos = 0; spos <= 2; spos++)
                    {
                        if(server_result.result.reelMatrix[0][j][spos] == 8)
                        {
                            sa_tmp++;
                        }
                        else if(server_result.result.reelMatrix[0][j][spos] == 9)
                        {
                            sc_tmp++
                        }
                    }
                    if(sa_tmp >= 2)
                    {
                        add_tmp_sa++;
                    }
                    if(sc_tmp >= 2)
                    {
                        add_tmp_sc++;
                    }
                }

                if(sa_tmp >= 2 || sc_tmp >= 2)
                {
                    if(typeof behavior_config.reel.spin.scatterDuration != "undefined")
                    {
                        var add = add_tmp_sc;
                        if(add_tmp_sa > add)
                        {
                            add = add_tmp_sa;
                        }
                        add = add - 1;
                        var tmp_dur = behavior_config.reel.spin.scatterDuration * 1 + behavior_config.reel.spin.scatterDelay * add;
                        stopposin[i] += tmp_dur * 1;
                    }
                    else
                    {
                        stopposin[i] += 20;
                    }
                }
                */

                while(stopposin[i] <= 0)
                {
                    stopposin[i] = ( reels_lenghts[i] * 1 ) - stopposin[i];
                }

                stopposin_old[i] = stopposin[i];
            }

            var cs = behavior_config.reel.spin.commonSpeed;
            if(in_free_spins)
            {
                cs = behavior_config.reel.spin.freeSpinSpeed;
            }
            var end_break_reel_dist = madnes_get_end_dist();

            //var ttrfs = behavior_config.reel.spin.timeToReachFullSpeed;
            var ttrns = behavior_config.reel.spin.timeToReachNullSpeed;

            if(forcestopnow == 1)
            {
                end_break_reel_dist = 0;
                ttrns = 0.01;
            }

            var symbdiff =
                (
                    (
                        (
                            (
                                time - rotate_control_start_time - (
                                    behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                )
                            ) / 1000
                        ) * cs
                    ) + rotate_control_swing_end
                );

            if(
                forcestopnow == 0 &&
                (
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= symbdiff &&
                    (stopposin[i]) - end_break_reel_dist + 0 - ( rotate_start_pos[i] / ico_he ) >= 0
                )
            )
            {
                reels_pos[i] =
                    (
                        rotate_start_pos[i] +
                        (
                            (
                                (
                                    (
                                        time - rotate_control_start_time - (
                                            behavior_config.reel.spin.timeToReachFullSpeed * 1000
                                        )
                                    ) / 1000
                                ) * cs
                            ) + rotate_control_swing_end
                        ) * ico_he
                    );

            }
            else if(stoppostime[i] == -1)
            {
                stopping[i] = 1;

                if(stoppostime_br[i] == -1)
                {
                    stoppostime_br[i] = time;
                }

                var dif_time = time - stoppostime_br[i];

                var cur_end = 0;

                if(dif_time <= ttrns * 1000)
                {
                    dif_time = madnes_get_dist_break(dif_time);

                    reels_pos[i] =
                        (
                            ( ( ( stopposin[i] + 0 ) - ( end_break_reel_dist * 1 ) + ( dif_time * 1 ) ) ) * ico_he

                        );
                }
                else
                {
                    cur_end = 1;
                }

                if(cur_end == 1)
                {
                    stoppostime[i] = time;

                    // if(!in_free_spins)
                    // {
                    // 	//wanted_freespin_hide(i + 1);
                    // }

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 ) * ico_he
                        );

                    if(alldone[i] == 0)
                    {
                        control_show_spin(i);
                        ib27_control_stop_sound(i);

                        for(var spos = 0; spos <= 2; spos++)
                        {
                            /*
                            if(server_result.result.reelMatrix[0][i][spos] == 8)
                            {
                                madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "nowin")
                                saloons++;
                            }
                            else if(server_result.result.reelMatrix[0][i][spos] == 9)
                            {
                                // SCATTER
                                madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
                                ib27_scatter_scale_anim(i, 'S'+(2-spos), 0);
                                scatters++;
                            }
                            else
                            {
                                */
                            madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - spos ), "stop")
                            /*
                        }*/

                            if(
                                (
                                    scatters == 2 ||
                                    saloons == 2
                                )
                                &&
                                scatters_runned == false &&
                                forcestopnow == 0 &&
                                i < 4
                            )
                            {
                                scatters_runned = true;
                                // for(var ii = i+2; ii <= 5; ii++)
                                // {
                                // 	if(forcestopnow === 0)
                                // 	{
                                // 		wanted_freespin_show(ii);
                                // 	}
                                // }
                                madnes_audio_play("REEL_TEAS");
                            }
                        }

                        for(var j = 0; j < reels_lenghts[i]; j++)
                        {
                            madnes_anim_play("reels_bufer_" + i + "_" + j, "stop");
                        }
                    }
                }
            }
            else
            {
                var end_time = stoppostime[i];
                var dif_time = time - end_time;

                var bh = behavior_config.reel.brake.brakeHeight;
                var kt = behavior_config.reel.brake.keepTime;
                var mbt = behavior_config.reel.brake.moveBackTime;
                //var mt = behavior_config.reel.brake.moveTime;
                var mt = behavior_config.reel.brake.moveBackTime;


                var cs = behavior_config.reel.spin.commonSpeed;
                if(in_free_spins)
                {
                    cs = behavior_config.reel.spin.freeSpinSpeed;
                }

                //cs - rychlost
                //bh - vyska
                mt = bh / cs;

                var swc = behavior_config.reel.brake.swingCount;

                if(dif_time < mt * 1000)
                {
                    var add_pos = ( ( (100 / ( mt * 1000 ) ) * dif_time ) / 100 ) * bh;

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000)
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + bh ) * ico_he
                        );
                }
                else if(dif_time < mt * 1000 + kt * 1000 + mbt * 1000)
                {
                    var time2 = dif_time - ( mt * 1000 + kt * 1000 );

                    var add_pos = bh - ( ( ( (100 / ( mbt * 1000 ) ) * time2 ) / 100 ) * bh );

                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0 + add_pos ) * ico_he
                        )
                        %
                        (
                            ( ( reels_lenghts[i] * 1 ) + 0 ) * ico_he
                        );

                }
                else
                {
                    reels_pos[i] =
                        (
                            ( stopposin[i] + 0  ) * ico_he
                        );

                    if(++stoppos_swing[i] < swc)
                    {
                        stoppostime[i] = time;
                    }
                    else
                    {
                        alldone[i] = 1;
                    }
                }

            }
        }

        if(alldone.indexOf(0) == -1)
        {
            madnes_audio_stop("reels");
            setTimeout(ib27_result_control, 100);
            madnes_rem_from_render(ib27_rotate_control);

            madnes_reels_stop();
            //madnes_hide_stop();
        }

    }

    ib27_print_reels();
}

function control_show_spin(reel) {
    if(reel == 1 && !in_free_spins && !madnes_is_in_autostart())
    {
        states.setState(STATES.FORCESPIN);
        // autospin_force_enabled = true;
        // madnes_show_spin();
    }

}


var madnes_get_end_dist_tmp = -1;
var madnes_get_end_dist_tmp_free = -1;
function madnes_get_end_dist()
{
    if(in_free_spins)
    {
        if(madnes_get_end_dist_tmp_free != -1)
        {
            return madnes_get_end_dist_tmp_free;
        }
    }
    else
    {
        if(madnes_get_end_dist_tmp != -1)
        {
            return madnes_get_end_dist_tmp;
        }
    }

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;
    var distance = madnes_get_dist_break(total_time);

    if(in_free_spins)
    {
        madnes_get_end_dist_tmp_free = distance;
    }
    else
    {
        madnes_get_end_dist_tmp = distance;
    }

    return distance;
}

function madnes_get_dist_break(time)
{
    var sampling = 10;

    //var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveTime;
    var end_speed = behavior_config.reel.brake.brakeHeight / behavior_config.reel.brake.moveBackTime;

    // if(!isFinite(end_speed) || isNaN(end_speed))
    // {
    // 	end_speed = 0;
    // }

    var start_speed = behavior_config.reel.spin.commonSpeed;
    if(in_free_spins)
    {
        start_speed = behavior_config.reel.spin.freeSpinSpeed;
    }

    end_speed = start_speed;

    var total_time = behavior_config.reel.spin.timeToReachNullSpeed * 1000;

    var distance = 0;

    for(var i = 0; i <= time; i += sampling)
    {
        var proc = 100 - ( ( 100 / total_time ) * i );
        var speed = ( ( start_speed - end_speed ) * ( proc / 100 ) ) + end_speed;
        distance = ( distance * 1 ) + ( speed * sampling ) ;
    }
    distance = distance / 1000;
    return distance;
}

// Pozadavek na dotoceni valce
var ib27_rotate_stop_loading = 0;
export function ib27_rotate_stop()
{
    if(rotated != 0 && ib27_rotate_stop_loading == 0)
    {
        for(var i = 0; i < cylinder_pos.length; i++)
        {
            stopposin_old[i] = -1;
        }
        all_set_for_stop = 0;
        ib27_rotate_stop_loading = 1;
        var poss = 0;
        for(var i in server_result.result.reelMatrix[0])
        {
            for(var j in server_result.result.reelMatrix[0][i])
            {
                (function(i, j) {

                    var picName = picture_convert[server_result.result.reelMatrix[0][i][j]];
                    var spriteName = "reels_bufer_" + i + "_S" + ( 2 - j );

                    setTimeout(function() {

                        madnes_set_texture(spriteName, picName + "_blur");
                        madnes_anim_add(spriteName, "blur", [0]);
                        madnes_anim_add(spriteName, "stop", [1]);

                        if(behavior_config.reel.spin.motionBlur == 1)
                        {
                            madnes_anim_play(spriteName, "blur");
                        }
                        else
                        {
                            madnes_anim_play(spriteName, "stop");
                        }

                    }, (1000 / ( fps ) ) * poss);

                } (i, j));
            }
        }

        setTimeout(function() {

            all_set_for_stop = 1;
            ib27_rotate_stop_loading = 0;

        }, (1000 / ( fps ) ) * poss);

        set_rotated(0); //rotated = 0;
    }
}

function ib27_control_stop_sound(reel)
{
    madnes_audio_play("stop_sound");

    var up_sym = server_result.result.reelMatrix[0][reel][0];
    var mi_sym = server_result.result.reelMatrix[0][reel][1];
    var dn_sym = server_result.result.reelMatrix[0][reel][2];

    if(up_sym == 0 || mi_sym == 0 || dn_sym == 0)
    {
        madnes_audio_play("smack_ice_bar");
    }
}


// Zacatek kontroly vyher
var result_control_pos = 0;
function ib27_result_control()
{
    set_inanim(1); //inanim = 1;
    result_control_pos = 0;

    toboom = [];
    boom_reel_pos = 0;
    tetris_pos = 0;
    symbol_count = [];

    ib27_result_control_part();
}

// kontrola vyhry na aktualni pozici
async function ib27_result_control_part()
{
    if(server_result.result.lineWins == null)
    {
        tetris_fst = false;

        madnes_win_anim_reset();
        ib27_money_add_control();
        return;
    }
    if(server_result.result.lineWins[result_control_pos] == null)
    {
        tetris_fst = false;

        madnes_win_anim_reset();
        for(var i = 0; i < 3; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
            }
        }
        ib27_money_add_control();

        set_inwincount(false); // inwincount = false;
        return;
    }
    else
    {
        states.setState(STATES.SKIP);

        // madnes_hide_stop();

        if(tetris_fst === true)
        {
            tetris_fst = false;
            ib27_multi_tetris(server_result.result.lineWins[result_control_pos]);
            return;
        }
        if(madnes_win_anim_skip())
        {
            if(
                server_result.result.lineWins[result_control_pos].type == "wild" ||
                server_result.result.lineWins[result_control_pos].type == "normal"
            )
            {
                if(typeof server_result.result.lineWins[result_control_pos].win != "undefined")
                {
                    // win = win * 1 + server_result.result.lineWins[result_control_pos].win * 1;
                    await madnes_add_win(server_result.result.lineWins[result_control_pos].win * 1);
                }
                result_control_pos++;
                ib27_result_control_part();
            }
            else
            {
                //console.log(server_result.result.lineWins[result_control_pos]);
                ib27_result_control_part_proc(server_result.result.lineWins[result_control_pos]);
            }
        }
        else
        {
            ib27_result_control_part_proc(server_result.result.lineWins[result_control_pos]);
        }
    }
}

function ib27_multi_tetris(lineWin)
{
    if(!lineWin.multiplier || lineWin.multiplier == 1) {
        ib27_result_control_part();
        return;
    }

    var name = "middle_" + lineWin.multiplier;

    madnes_set_pos(name, wi / 2, he * 1.1);
    madnes_audio_play("MG_WIN");
    madnes_fall_to(name, wi / 2, he / 2, 400, function() {
        madnes_scale_to(name, 1.2, 1.2, 200, function() {
            madnes_audio_play("Explosion_win");
            madnes_scale_to(name, 1, 1, 200, function() {
                madnes_scale_to(name, 1.2, 1.2, 200, function() {
                    madnes_audio_play("Explosion_win");
                    madnes_scale_to(name, 1, 1, 200, function() {
                        setTimeout(function() {
                            madnes_fall_to(name, wi / 2, he * 1.1, 400, function() {
                                madnes_set_pos(name, -9999, -9999);
                                ib27_result_control_part();
                            })
                        }, 400)
                    })
                })
            })
        })
    });
}

var symbol_count = [];

var audio_name = "";

// kontrola aktualni vyhry
function ib27_result_control_part_proc(win_set)
{
    // (Caru -> zvuk) -> zabarvit -> otocit -> prostrelit -> otocit zpet -> posunout
    set_inwincount(true); //inwincount = true;

    var linenum = 0;
    if(win_set['line'] != null && typeof win_set['line'] != "undefined" && win_set['line'] >= 0 && win_set['line'] <= 9)
    {
        linenum = win_set['line'] + 1;
    }

    if(linenum != 0 || 1)
    {
        madnes_audio_pause('BACKGROUND');

        //ib27_show_line(linenum);

        // madnes_win_anim_add();

        // AUDIO
        if(win_set['type'] == "mystery")
        {
            //madnes_audio_play("Explosion_win");
        }
        else if(win_set['type'] == "tetris")
        {
            setTimeout(madnes_audio_play.bind(null, "Explosion_win"), 200);
        }
        else
        {

            var symbol = picture_convert[win_set['symbol']].toUpperCase();

            symbol = symbol.split("_");
            symbol = symbol[1];

            switch(symbol.toUpperCase())
            {
                case "MELONE": symbol = "MEL"; break;
                case "STAR": symbol = "HVE"; break;
                case "ORANGE": symbol = "POM"; break;
                case "DOLLAR": symbol = "DOL"; break;
                case "GRAPES": symbol = "HRO"; break;
                case "PLUM": symbol = "SVE"; break;
                case "CHERRY": symbol = "TRE"; break;
                case "BELL": symbol = "ZVON"; break;

                default: console.log(symbol); symbol = ""; break;
            }

            if(symbol != "")
            {
                if(typeof symbol_count[symbol] == "undefined")
                {
                    symbol_count[symbol] = 1;
                }
                else
                {
                    symbol_count[symbol] = symbol_count[symbol] * 1 + 1;
                    if(symbol_count[symbol] > 5)
                    {
                        symbol_count[symbol] = 1;
                    }
                }
            }

            if(symbol != "")
            {
                audio_name = "WIN_LINE_" + symbol + "_" + symbol_count[symbol];
            }

            if(audio_name != "")
            {
                madnes_audio_play(audio_name);
            }
        }

        ib27_result_control_part_proc_trn(win_set);
    }
    // else if(win_set['type'] == "scatter")
    // {
    // 	inwincount = false;
    // 	audio_name = "WIN_LINE_SCATTER_"+win_set['position'].length;
    // 	madnes_audio_play(audio_name);
    //
    // 	for(var i = 0; i < 3; i++)
    // 	{
    // 		for(var j = 0; j < 3; j++)
    // 		{
    // 			madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
    // 		}
    // 	}
    //
    // 	for(var i = 0; i < 3; i++)
    // 	{
    // 		for(var j = 0; j < 3; j++)
    // 		{
    // 			for(var wset in win_set['position'])
    // 			{
    // 				if(win_set['position'][wset][0] == i && win_set['position'][wset][1] == j)
    // 				{
    // 					madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "anim");
    // 				}
    // 			}
    // 		}
    // 	}
    //
    // 	if(!in_free_spins && in_free_spins_total == 0)
    // 	{
    // 		madnes_audio_pause('BACKGROUND');
    // 		setTimeout(function() {
    // 			madnes_audio_loop('BACKGROUND_FS');
    // 		}, 1500);
    //
    // 	}
    //
    // 	if(in_free_spins_total * 1 != server_result.result.freeSpinNumber * 1)
    // 	{
    // 		setTimeout(ib27_add_free_spins, 800);
    // 	 	return;
    // 	}
    //
    // 	if(!in_free_spins)
    // 	{
    // 		in_free_spins = true;
    // 		in_free_spins_pos = 0;
    // 		madnes_set_text("free1", in_free_spins_pos.toString());
    //
    // 		setTimeout(ib27_control_freespins, 2000);
    // 	}
    // 	else
    // 	{
    // 		setTimeout(ib27_control_freespins, 1000);
    // 	}
    //
    // }
    else if(win_set['type'] == "bonus")
    {
        set_inwincount(false); //inwincount = false;
        audio_name = "WIN_LINE_SALOON_"+win_set['position'].length;
        madnes_audio_play(audio_name);

        for(var i = 0; i < 3; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                madnes_set_alpha("reels_bufer_" + i + "_S" + ( 2 - j ), 1);
            }
        }

        for(var i = 0; i < 3; i++)
        {
            for(var j = 0; j < 3; j++)
            {
                for(var wset in win_set['position'])
                {
                    if(win_set['position'][wset][0] == i && win_set['position'][wset][1] == j)
                    {
                        madnes_anim_play("reels_bufer_" + i + "_S" + ( 2 - j ), "win");
                    }
                }
            }
        }

        //setTimeout("ib27_saloon_start()", 2000);

    }
    else
    {
        result_control_pos++;
        ib27_result_control_part();
        // if(in_free_spins)
        // {
        // 	ib27_control_freespins();
        // }
    }
}

var result_tmp; // uchovava docasne vysledek freespinu, je-li to potreba

// kontrola freespinu

// Navrat vysledku na konci freespinu
function ib27_set_result_freespin()
{
    set_result_lock(0); // result_lock = 0;
    server_result.result.reelMatrix = result_tmp;
}

var toboom = [];
var boom_reel_pos = 0;
var tetris_fst = false;
var tetris_pos = 0;

var ib27_falls = 0;
var ib27_falls_ws = null;
function ib27_falls_control()
{
    if(ib27_falls == 0)
    {
        tetris_pos = 2;
        ib27_result_control_part_proc_trn(ib27_falls_ws);
    }
}

// Otoceni wild symbolu
function ib27_result_control_part_proc_trn(win_set)
{
    for(var i = 0; i < reels_pos.length; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            if(
                madnes_anim_is_playing("reels_bufer_" + i + "_TMP" + j) ||
                madnes_anim_is_playing("reels_bufer_" + i + "_S" + j)
            )
            {
                //console.log("skip 1");
                setTimeout(
                    function() {
                        ib27_result_control_part_proc_trn(win_set);
                    }, 1000 / fps
                );
                return;
            }
        }
    }
    ib27_print_reels();
    // Caru -> zvuk -> zabarvit -> (otocit) -> prostrelit -> otocit zpet -> posunout

    if(win_set['type'] == "tetris")
    {
        if(tetris_pos == 0)
        {
            madnes_win_anim_reset();

            toboom = [];

            for(var ps in win_set['position'])
            {
                if(typeof toboom[win_set['position'][ps][0]] == "undefined")
                {
                    toboom[win_set['position'][ps][0]] = [];
                }
                toboom[win_set['position'][ps][0]][toboom[win_set['position'][ps][0]].length] = win_set['position'][ps][1];
            }
            var addtime = 200;
            for(var reel in toboom)
            {
                for(var sym in toboom[reel])
                {
                    var symbol = madnes_get_texture("reels_bufer_" + reel + "_S" + ( 2 - toboom[reel][sym] ));
                    symbol = symbol.replace("_blur", "").replace("_freeze_freezed", "").replace("_freezed", "");

                    if(symbol.indexOf("symbol_BAR") === 0)
                    {
                        symbol = "symbol_BAR";
                    }

                    madnes_set_texture("reels_bufer_" + reel + "_TMP" + ( 2 - toboom[reel][sym] ), symbol + "_boom");
                    for(var anim in icons[symbol + "_boom"])
                    {
                        madnes_anim_add("reels_bufer_" + reel + "_TMP" + ( 2 - toboom[reel][sym] ), anim, icons[symbol + "_boom"][anim]);
                    }

                    if(madnes_get_pos_y("reels_bufer_" + reel + "_S" + ( 2 - toboom[reel][sym] )) > 0)
                    {
                        madnes_set_pos_y(
                            "reels_bufer_" + reel + "_TMP" + ( 2 - toboom[reel][sym] ),
                            madnes_get_pos_y("reels_bufer_" + reel + "_S" + ( 2 - toboom[reel][sym] ))
                        );
                        madnes_set_pos_y("reels_bufer_" + reel + "_S" + ( 2 - toboom[reel][sym] ), -9999);
                    }

                    if(madnes_win_anim_skip())
                    {
                        madnes_anim_play("reels_bufer_" + reel + "_TMP" + ( 2 - toboom[reel][sym] ), "anim", 3000);
                        addtime = 0;
                    }
                    else
                    {
                        (function (reel, sym) {

                            setTimeout(function() {
                                madnes_anim_play("reels_bufer_" + reel + "_TMP" + ( 2 - toboom[reel][sym] ), "anim", 30);
                            }, 200);

                        }(reel, sym));
                    }
                }
            }

            tetris_pos++;

            setTimeout(
                function() {
                    ib27_result_control_part_proc_trn(win_set);
                }, 1000 / fps + addtime
            );
            return;
        }
        else if(tetris_pos == 1 || tetris_pos == 1.1 || tetris_pos == 1.2)
        {
            if(tetris_pos == 1)
            {
                tpos_f = [];
                server_result['result']['gameSpecifics']['iceBarPositions'] = [];
            }
            for(var reel in toboom)
            {
                if(tetris_pos == 1)
                {
                    topos = [];
                    tpos_f[reel] = [];
                    for(var j = 2; j >= 0; j--)
                    {
                        var tetris_symbol = server_result.result.reelMatrix[boom_reel_pos * 1 + 1][reel][j];

                        //console.log(tetris_symbol, picture_convert[tetris_symbol]);

                        if(picture_convert[tetris_symbol] === "symbol_BAR") {
                            server_result['result']['gameSpecifics']['iceBarPositions'].push([reel, j]);
                        }

                        madnes_set_texture("reels_bufer_" + reel + "_S" + ( 2 - j ), picture_convert[tetris_symbol] + "_blur");
                        madnes_anim_add("reels_bufer_" + reel + "_S" + ( 2 - j ), "blur", [0]);
                        madnes_anim_add("reels_bufer_" + reel + "_S" + ( 2 - j ), "stop", [1]);
                        madnes_anim_play("reels_bufer_" + reel + "_S" + ( 2 - j ), "stop");

                        topos[j] = madnes_get_pos_y("reels_bufer_" + reel + "_TMP" + ( 2 - j ));
                        if(topos[j] < 0)
                        {
                            topos[j] = madnes_get_pos_y("reels_bufer_" + reel + "_S" + ( 2 - j ));
                        }
                        madnes_set_pos_y("reels_bufer_" + reel + "_TMP" + ( 2 - j ), -9999);
                    }

                    for(var j = 2; j >= 0; j--)
                    {
                        if(madnes_get_pos_y("reels_bufer_" + reel + "_S" + ( 2 - j )) < 0)
                        {
                            madnes_set_pos_y("reels_bufer_" + reel + "_S" + ( 2 - j ), -200);
                        }
                    }

                    topos[-1] = topos[0] - (topos[1] - topos[0]);
                    topos[-2] = topos[-1] - (topos[0] - topos[-1]);
                    topos[-3] = topos[-2] - (topos[-1] - topos[-2]);

                    for(var j = 2; j >= 0; j--)
                    {
                        var tmp_pos = j;
                        var add = 0;
                        for(var jj = 2; jj >= j - add; jj--)
                        {
                            if(toboom[reel].indexOf(jj) != -1)
                            {
                                add++;
                                tmp_pos--;
                            }
                        }

                        tmp_pos = topos[tmp_pos];
                        madnes_set_pos_y("reels_bufer_" + reel + "_S" + ( 2 - j ), tmp_pos);
                    }

                    var mt = 200;
                    if(madnes_win_anim_skip())
                    {
                        mt = 1;
                    }

                    for(var j = 2; j >= 0; j--)
                    {
                        tpos_f[reel][j] = madnes_get_pos_y("reels_bufer_" + reel + "_S" + ( 2 - j ));
                        /*
                        var tpos_t = topos[j];
                        var tpos_f = madnes_get_pos_y("reels_bufer_" + reel + "_S" + ( 2 - j ));
                        var tpos = ( tpos_t - tpos_f ) * 0.8 + tpos_f;
                        */
                        var tpos = topos[j];

                        if(
                            madnes_get_pos_y("reels_bufer_" + reel + "_S" + ( 2 - j )) != tpos
                        )
                        {
                            ib27_falls++;
                            setTimeout(
                                madnes_fall_to.bind(this, "reels_bufer_" + reel + "_S" + ( 2 - j ), madnes_get_pos_x("reels_bufer_" + reel + "_S" + ( 2 - j )), tpos, mt,
                                    madnes_move_to.bind(this, "reels_bufer_" + reel + "_S" + ( 2 - j ), madnes_get_pos_x("reels_bufer_" + reel + "_S" + ( 2 - j )), tpos - 60, 60,
                                        madnes_fall_to.bind(this, "reels_bufer_" + reel + "_S" + ( 2 - j ), madnes_get_pos_x("reels_bufer_" + reel + "_S" + ( 2 - j )), tpos, 120, function() {
                                            ib27_falls--;
                                            ib27_falls_control();
                                        })
                                    )
                                )
                                , 0 + reel * 150);
                        }
                    }
                }
                /*
                else if(tetris_pos == 1.1)
                {
                    var mt = 100;
                    if(madnes_win_anim_skip())
                    {
                        mt = 1;
                    }

                    for(var j = 2; j >= 0; j--)
                    {
                        var tpos_t = topos[j];
                        var tpos = ( tpos_t - tpos_f[reel][j] ) * 0.9 + tpos_f[reel][j];

                        madnes_move_to("reels_bufer_" + reel + "_S" + ( 2 - j ), madnes_get_pos_x("reels_bufer_" + reel + "_S" + ( 2 - j )), tpos, mt);
                    }
                }
                else if(tetris_pos == 1.2)
                {
                    var mt = 100;
                    if(madnes_win_anim_skip())
                    {
                        mt = 1;
                    }

                    for(var j = 2; j >= 0; j--)
                    {
                        tpos = topos[j];
                        madnes_fall_to("reels_bufer_" + reel + "_S" + ( 2 - j ), madnes_get_pos_x("reels_bufer_" + reel + "_S" + ( 2 - j )), tpos, mt);
                    }
                }
                */
            }

            if(tetris_pos == 1)
            {
                tetris_pos = 1.1;
                ib27_falls_ws = win_set;
                //tetris_pos = 2;
                setTimeout(madnes_audio_play.bind(null, "tetris_system"), mt);
                setTimeout(madnes_audio_play.bind(null, "tetris_system"), mt * 1 + 150);
                setTimeout(madnes_audio_play.bind(null, "tetris_system"), mt * 1 + 300);
            }
            else if(tetris_pos == 1.1)
            {
                tetris_pos = 1.2;
            }
            else
            {
                tetris_pos = 2
            }

            if(
                tetris_pos != 1.1
            )
            {
                setTimeout(
                    function() {
                        ib27_result_control_part_proc_trn(win_set);
                    }, mt * 1 + 300
                );
            }

            return;
        }
        else if(tetris_pos == 2)
        {
            boom_reel_pos++;
            tetris_fst = true;
            toboom = [];
            tetris_pos = 0;

            ib27_result_control_part_proc_nxt(win_set);
        }
    }
    else if(win_set['type'] == "wild")
    {
        if(typeof win_set['win'] != "undefined")
        {
            madnes_set_win(win * 1 + win_set['win'] * 1); //win = win * 1 + win_set['win'] * 1;//win_set['multiplier'];
            setTimeout(function() { ib27_show_win_sum_start(win_set); } , 200);
        }

        var wilds = new Array();
        for(var wld in server_result['result']['gameSpecifics']['iceBarPositions'])
        {
            var x_tmp = server_result['result']['gameSpecifics']['iceBarPositions'][wld][0];
            var y_tmp = server_result['result']['gameSpecifics']['iceBarPositions'][wld][1];
            if(wilds[x_tmp] == null)
            {
                wilds[x_tmp] = new Array();
            }
            wilds[x_tmp][wilds[x_tmp].length] = y_tmp;
        }

        for(var pos in win_set['position'])
        {
            if(
                wilds[win_set['position'][pos][0]] != null &&
                wilds[win_set['position'][pos][0]].indexOf(win_set['position'][pos][1]) != -1
            )
            {
                var symbol = picture_convert[win_set['symbol']];
                symbol = symbol.split("_");
                symbol = symbol[1];

                if( madnes_get_texture("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] )) != "symbol_BAR_" + symbol )
                {
                    madnes_set_texture("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ), "symbol_BAR_" + symbol);
                    for(var anim in icons["symbol_BAR_" + symbol])
                    {
                        madnes_anim_add("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ), anim, icons["symbol_BAR_" + symbol][anim]);
                    }

                    if(freezed.indexOf("symbol_BAR_" + symbol) != -1)
                    {
                        madnes_set_texture("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ), "symbol_BAR_" + symbol + "_freezed");
                    }
                }

                if(madnes_get_pos_y("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] )) > 0)
                {
                    madnes_set_pos_y(
                        "reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ),
                        madnes_get_pos_y("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ))
                    );
                    madnes_set_pos_y("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ), -9999);
                }

                if(typeof toboom[win_set['position'][pos][0]] == "undefined")
                {
                    toboom[win_set['position'][pos][0]] = [];
                }
                if(toboom[win_set['position'][pos][0]].indexOf(win_set['position'][pos][1]) == -1)
                {
                    toboom[win_set['position'][pos][0]][toboom[win_set['position'][pos][0]].length] = win_set['position'][pos][1];
                }
            }
            else
            {
                if(typeof toboom[win_set['position'][pos][0]] == "undefined")
                {
                    toboom[win_set['position'][pos][0]] = [];
                }
                if(toboom[win_set['position'][pos][0]].indexOf(win_set['position'][pos][1]) == -1)
                {
                    toboom[win_set['position'][pos][0]][toboom[win_set['position'][pos][0]].length] = win_set['position'][pos][1];
                }

                var text = madnes_get_texture("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ));

                text = text.replace("_blur", "").replace("_freeze_freezed", "").replace("_freezed", "");
                if(text.indexOf("symbol_BAR") === 0)
                {
                    text = "symbol_BAR";
                }


                if(madnes_get_texture("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] )) != text + "_freeze")
                {
                    madnes_set_texture("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ), text + "_freeze");
                    for(var anim in icons[text + "_freeze"])
                    {
                        madnes_anim_add("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ), anim, icons[text + "_freeze"][anim]);
                    }

                    if(freezed.indexOf(text + "_freeze") != -1)
                    {
                        madnes_set_texture("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ), text + "_freeze_freezed");
                    }
                }

                if(madnes_get_pos_y("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] )) > 0)
                {
                    madnes_set_pos_y(
                        "reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ),
                        madnes_get_pos_y("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ))
                    );
                    madnes_set_pos_y("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ), -9999);
                }
            }

            for(var pos in win_set['position'])
            {
                (function(pos) {

                    setTimeout(function() {
                        madnes_anim_play("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ), "anim", 30)
                    }, 200);

                } (pos));

                // setTimeout('madnes_anim_play("reels_bufer_' + win_set['position'][pos][0] + '_TMP' + ( 2 - win_set['position'][pos][1] ) + '", "anim", 30);', 200)

            }
        }
        setTimeout(function() {
            ib27_result_control_part_proc_nxt(win_set);
        }, 800);
    }
    else if(win_set['type'] == "normal")
    {
        if(typeof win_set['win'] != "undefined")
        {
            madnes_set_win(win * 1 + win_set['win'] * 1); //win = win * 1 + win_set['win'] * 1;//win_set['multiplier'];
            setTimeout(function() { ib27_show_win_sum_start(win_set); } , 200);
        }

        for(var pos in win_set['position'])
        {
            var text = madnes_get_texture("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ));
            text = text.replace("_blur", "").replace("_freeze_freezed", "").replace("_freezed", "");
            if(text.indexOf("symbol_BAR") === 0)
            {
                text = "symbol_BAR";
            }

            if(madnes_get_texture("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] )) != text)
            {
                madnes_set_texture("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ), text)
                for(var anim in icons[text + "_freeze"])
                {
                    madnes_anim_add("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ), anim, icons[text][anim]);
                }
            }

            if(madnes_get_pos_y("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] )) > 0)
            {
                madnes_set_pos_y(
                    "reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ),
                    madnes_get_pos_y("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ))
                );
                madnes_set_pos_y("reels_bufer_" + win_set['position'][pos][0] + "_S" + ( 2 - win_set['position'][pos][1] ), -9999);
            }
        }

        for(var pos in win_set['position'])
        {
            (function(pos) {
                setTimeout(function() {
                    madnes_anim_play("reels_bufer_" + win_set['position'][pos][0] + "_TMP" + ( 2 - win_set['position'][pos][1] ), "anim", 30);
                }, 200);
            } (pos));

            // setTimeout('madnes_anim_play("reels_bufer_' + win_set['position'][pos][0] + '_TMP' + ( 2 - win_set['position'][pos][1] ) + '", "anim", 30);', 200);
        }

        setTimeout(function() {
            ib27_result_control_part_proc_nxt(win_set);
        }, 800);
    }
    else if(win_set['type'] == "mystery")
    {
        ib27_mystery_start(win_set);
    }
    else
    {
        ib27_result_control_part_proc_nxt(win_set);
    }
}

var topos = [];
var tpos_f = [];

// Konec animace -> prejit na kontrolu dalsi (pouze nacasovani)
export function ib27_result_control_part_proc_nxt(win_set)
{
    // Caru -> zvuk -> zabarvit -> otocit -> prostrelit -> otocit zpet -> (posunout)

    for(var i = 0; i < reels_pos.length; i++)
    {
        for(var j = 0; j < 3; j++)
        {
            if(
                madnes_anim_is_playing("reels_bufer_" + i + "_TMP" + j) ||
                madnes_anim_is_playing("reels_bufer_" + i + "_S" + j)
            )
            {
                //console.log("skip 2");
                setTimeout(
                    function() {
                        ib27_result_control_part_proc_nxt(win_set);
                    }, 1000 / fps
                );
                return;
            }
        }
    }

    setTimeout(function() {
        result_control_pos++;
        ib27_result_control_part();
    }, 1000 / fps);
}






















var win_anim_played = false;

// Zacatek kontroly pridavani penez
function ib27_money_add_control()
{
    set_inwincount(false); //inwincount = false;

    madnes_win_anim_reset();

    if(!win_anim_played && win * 1 > 0)
    {
        ib27_money_add_win(madnes_money_to_coin(win));
        //madnes_audio_loop('remittance_A');
    }
    else
    {
        setTimeout(madnes_audio_stop.bind(null, 'remittance_A'), 200);
        madnes_audio_continue('BACKGROUND');

        madnes_end_round();

        // madnes_end_round(true, {}, {}, function() {
        //
        // 	madnes_hide_stop();
        //
        // 	end_result_control();
        // });
    }
}

export function ib27_end_round_recalced() {

    set_inanim(0); //inanim = 0;
    win_anim_played = false;

    // madnes_on_end_round_recount(win);
    // madnes_on_round_end();
    // madnes_recount_bet();

    autospin_force_enabled = false;
    // if(is_in_autostart() || autospin_force)
    // {
    // 	autospin_force = false;
    // 	madnes_rotate_start();
    // 	return;
    // }

}

// function end_result_control()
// {
//     inanim = 0;
//     win_anim_played = false;
//
//     madnes_on_end_round_recount(win);
//     madnes_on_round_end();
//     madnes_recount_bet();
//
//     autospin_force_enabled = false;
//     if(is_in_autostart() || autospin_force)
//     {
//         autospin_force = false;
//         madnes_rotate_start();
//         return;
//     }
// }

function is_in_autostart()
{
    return !!autostart;
    //return autostart * 1 > 0 || autostart == "∞";
}

var moneyadd_pos = 0;
var moneyadd_dir = 0;
var money_add_win_speed = 18;

function ib27_money_add_win(max)
{
    if(inmoneyadd == 0 && inbigwin == 0)
    {
        var tmp_bet = bet;
        if(
            server_result != null &&
            server_result['bet'] != null &&
            server_result['bet']*1 > 0

        )
        {
            tmp_bet = server_result['bet']*1;
        }

        if(max*1 > tmp_bet * 1 * big_win)
        {
            ib27_money_add_big_win(max);
            return;
        }

        set_inmoneyadd(1); //inmoneyadd = 1;
    }

    win_anim_played = true;

    madnes_show_money(max, function() {
        ib27_money_add_control();
        set_inmoneyadd(0); //inmoneyadd = 0;
    });

    set_inbigwin(0); // inbigwin = 0;
}


function ib27_money_add_big_win(max)
{
    states.setState(STATES.BONUS_WIN);
    set_inbigwin(1); //inbigwin = 1;

    // madnes_hide_btns();

    ib27_money_add_big_win_anim_step = 0;
    setTimeout(madnes_start_coin, 800);
    setTimeout(ib27_money_add_big_win_anim.bind(null, max), 1000);
}

var ib27_money_add_big_win_anim_step = 0;
function ib27_money_add_big_win_anim(max)
{
    switch(ib27_money_add_big_win_anim_step)
    {
        case 0:
            madnes_audio_play("mystery_win");
            if(ib27_from_mystery == 1)
            {
                madnes_set_pos("mystery_selection", 0, 0);
                madnes_set_pos("your_mystery_win", wi / 2, he * 0.78);
                madnes_set_alpha("mystery_selection", 0);
                madnes_set_alpha("your_mystery_win", 0);
                madnes_alpha_to("mystery_selection", 1, 250);
                madnes_alpha_to("your_mystery_win", 1, 250);
            }
            else
            {
                madnes_set_pos("big_win", 0, 0);
                madnes_set_alpha("big_win", 0);
                madnes_alpha_to("big_win", 1, 250);
            }

            madnes_set_pos("big_win_text", wi / 2, he / 2);
            madnes_set_alpha("big_win_text", 0);
            madnes_alpha_to("big_win_text", 1, 250);
            madnes_set_text("big_win_text", "0");

            ib27_money_add_big_win_anim_step = 1;
            setTimeout(ib27_money_add_big_win_anim.bind(null, max), 150);
            break;
        case 1:
            ib27_money_add_big_win_add_pos = 0;
            ib27_money_add_big_win_add_max = max;
            ib27_money_add_big_win_add_step = 0;
            madnes_add_to_render(ib27_money_add_big_win_add);
            break;
        case 2:
            madnes_alpha_to("big_win", 0, 500);
            madnes_alpha_to("mega_win", 0, 500);
            madnes_alpha_to("super_mega_win", 0, 500);
            madnes_alpha_to("your_mystery_win", 0, 500);
            madnes_alpha_to("mystery_selection", 0, 500);
            madnes_alpha_to("big_win_text", 0, 500);

            ib27_money_add_big_win_anim_step = 3;
            setTimeout(ib27_money_add_big_win_anim.bind(null, max), 500);
            break;
        case 3:
            madnes_set_pos("big_win", -9999, -9999);
            madnes_set_pos("mega_win", -9999, -9999);
            madnes_set_pos("super_mega_win", -9999, -9999);
            madnes_set_pos("your_mystery_win", -9999, -9999);
            madnes_set_pos("mystery_selection", -9999, -9999);
            madnes_set_pos("big_win_text", -9999, -9999);

            set_ib27_from_mystery(0); //ib27_from_mystery = 0;

            ib27_money_add_big_win_anim_step = 0;

            moneyadd_pos = 0;
            moneyadd_dir = 0;

            win_anim_played = true;

            set_inmoneyadd(0); //inmoneyadd = 0;
            set_inbigwin(0); //inbigwin = 0;

            // madnes_show_btns();

            ib27_money_add_control();

            break;
    }

}

var ib27_money_add_big_win_add_pos = 0;
var ib27_money_add_big_win_add_max = 0;
var ib27_money_add_big_win_add_step = 0;
var ib27_money_add_big_win_add_rempos = 0;
function ib27_money_add_big_win_add()
{
    var tmp_add = Math.round( ib27_money_add_big_win_add_max * ( Math.random() / 100 ) );
    if(tmp_add < 1)
    {
        tmp_add = 1;
    }
    ib27_money_add_big_win_add_pos = ib27_money_add_big_win_add_pos * 1 + tmp_add;

    if(ib27_money_add_big_win_add_step == 0 && ib27_money_add_big_win_add_pos > bet * mega_win && ib27_from_mystery == 0)
    {
        ib27_money_add_big_win_add_pos = bet * mega_win;
        ib27_money_add_big_win_add_step = 1;
        madnes_set_pos("mega_win", 0, 0);
        madnes_set_alpha("mega_win", 0);
        madnes_alpha_to("mega_win", 1, 250);
    }
    else if(ib27_money_add_big_win_add_step == 1)
    {
        ib27_money_add_big_win_add_pos = bet * mega_win;
        //if(madnes_get_alpha("mega_win") == 1)
        //{
        ib27_money_add_big_win_add_step = 2;
        //}
    }
    else if(ib27_money_add_big_win_add_step == 2 && ib27_money_add_big_win_add_pos > bet * super_win)
    {
        ib27_money_add_big_win_add_pos = bet * super_win;
        ib27_money_add_big_win_add_step = 3;
        madnes_set_pos("super_mega_win", 0, 0);
        madnes_set_alpha("super_mega_win", 0);
        madnes_alpha_to("super_mega_win", 1, 250);
    }
    else if(ib27_money_add_big_win_add_step == 3)
    {
        ib27_money_add_big_win_add_pos = bet * super_win;
        //if(madnes_get_alpha("super_mega_win") == 1)
        //{
        ib27_money_add_big_win_add_step = 4;
        //}
    }
    else
    {
        if(ib27_money_add_big_win_add_rempos++ % 2 == 0)
        {
            madnes_audio_play('remittance_A');
        }
    }

    if(ib27_money_add_big_win_add_pos > ib27_money_add_big_win_add_max)
    {
        ib27_money_add_big_win_add_pos = ib27_money_add_big_win_add_max;
        madnes_rem_from_render(ib27_money_add_big_win_add);
        ib27_money_add_big_win_anim_step = 2;
        madnes_audio_play('remittance_B');
        madnes_stop_coin();
        setTimeout(ib27_money_add_big_win_anim.bind(null, ib27_money_add_big_win_add_max), 2000);
    }

    madnes_set_text("big_win_text", ib27_money_add_big_win_add_pos);

}

// Konec kontroly penez
